import { useTranslation } from '@flecto/translations'
import {
  type CoreCustomerPayload,
  type CoreCountryCode,
  type CoreCustomerDocType,
  type UNSAFE_any,
} from '@flecto/types'

import { type CoreCustomerForm } from '../../types/FormCustomer'

export function useCustomerPayload() {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  const isEmpty = (value: UNSAFE_any): boolean => {
    if (value === null || value === undefined) {
      return true
    }

    if (typeof value === 'object') {
      return Object.values(value).every(isEmpty)
    }

    return false
  }

  const buildPayload = (form: Partial<CoreCustomerForm>) => {
    const payload: Partial<CoreCustomerPayload> = {
      email: form.email === '' ? '' : form.email,
      full_name: form.full_name,
      notes: form.notes,
      id_verified_at:
        form.id_verified_at && form.id_document_number?.trim()
          ? String(new Date().toISOString())
          : '',
      default_discount_amount: form.default_discount_amount,
      default_discount_type: form.default_discount_amount
        ? 'discount_percentage'
        : undefined,
      phone_number:
        form.phone_number === ''
          ? ''
          : form.phone_number
            ? `${form.phone_number_country_code}${form.phone_number}`.replace(
                /\s+/g,
                ''
              )
            : undefined,
      vat_number:
        form.vat_number === '' || form.vat_number === null
          ? ''
          : form.vat_number,
      locale: form.locale,
      id_document_number: form.id_document_number ?? undefined,
      id_document_type:
        (form.id_document_type as CoreCustomerDocType) ?? undefined,
      nationality: form.nationality ?? undefined,
      nature: form.nature ?? undefined,
    }

    if (form.address && !isEmpty(form.address)) {
      payload.addresses_attributes = [
        {
          id: form.address.id ?? undefined,
          label: form.address.label ?? `${t('add_customer.address')} 1`,
          latitude: form.address?.latitude ?? undefined,
          longitude: form.address?.longitude ?? undefined,
          address_street: form.address?.address_street ?? undefined,
          address_city: form.address?.address_city ?? undefined,
          address_postal_code: form.address?.address_postal_code ?? undefined,
          address_region: form.address?.address_region ?? undefined,
          address_country_code:
            (form.address?.address_country_code as CoreCountryCode) ??
            undefined,
        },
      ]
    }
    return payload
  }

  return { buildPayload }
}
